import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Calendar from 'react-calendar';
import { ReactComponent as ArrowBack } from 'assets/icons/pagination-arrow-back-icon.svg';
import { ReactComponent as ArrowForward } from 'assets/icons/pagination-arrow-forward-icon.svg';
import { StyledAdminCalendarContainer, StyledAdminCalendar } from './styles';

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];
interface ICustomCalendarProps {
  onChange: (dateRange: { fromDate: Date; toDate: Date }) => void;
}

export const AdminCalendar = ({ onChange }: ICustomCalendarProps) => {
  const { t } = useTranslation();
  const shortWeekdays = t('calendar.weekdaysShort', { returnObjects: true }) as string[];
  const [valueCalendar, onCalendarChange] = useState<Value>(new Date());

  const calendarChangeHandler = (value: Value) => {
    if (!value) return;
    onCalendarChange(value);

    if (value instanceof Date) {
      onChange && onChange({ fromDate: value, toDate: value });
      return;
    }

    if (!value[0] || !value[1]) return;

    const from = value[0];
    const to = value[1];

    onChange && onChange({ fromDate: from, toDate: to });
  };

  return (
    <StyledAdminCalendarContainer>
      <div className="calendar-back-layer">
        <StyledAdminCalendar>
          <Calendar
            value={valueCalendar}
            onChange={calendarChangeHandler}
            formatShortWeekday={(_, date) => shortWeekdays[date.getDay()]}
            nextLabel={<ArrowForward />}
            prevLabel={<ArrowBack />}
            selectRange
          />
        </StyledAdminCalendar>
      </div>
    </StyledAdminCalendarContainer>
  );
};
